import styled, { css } from 'styled-components';

import { FilledDisclosuresCellProps } from './FilledDisclosuresCell';

export const Cell = styled.span<
    Pick<
        FilledDisclosuresCellProps,
        'isHighlighted' | 'isNew' | 'status' | 'customColor'
    >
>(
    ({
        customColor,
        isHighlighted,
        isNew,
        status,
        theme: { fontWeight, palette },
    }) => css`
        color: ${customColor ||
        (isHighlighted ? palette.tertiary.default : palette.text.secondary)};
        font-weight: ${isNew ? fontWeight.bold : 'inherit'};
        ${status &&
        css`
            display: flex;
            justify-content: center;
            min-width: 30px;
        `}
    `,
);
